/**
 * Получает координаты элемента, относительно окна
 */
export function getCoords(elem) { // кроме IE8-
  const box = elem.getBoundingClientRect()
  return {
    'top': box.top + pageYOffset,
    'left': box.left + pageXOffset
  }
}

// export const transitionEnd = whichTransitionEvent()




// WEBPACK FOOTER //
// ./helpers/getCoords.js